/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Max_Event_Gap_LabelInputs */



/**
* | output |
* | --- |
* | "Maximum Event Gap" |
*
* @param {Style_Guide_Manager_Max_Event_Gap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_max_event_gap_label = /** @type {((inputs?: Style_Guide_Manager_Max_Event_Gap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Max_Event_Gap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ecart d'evenement maximum")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Ereignislücke")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gap massimo dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальный разрыв между событиями")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máxima brecha de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最大事件间隙")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大イベントギャップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम घटना अंतराल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Intervalo máximo entre eventos")
	return /** @type {LocalizedString} */ ("Maximum Event Gap")
});